import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import VueRouter from 'vue-router'
import Keycloak from 'keycloak-js'
import VueLogger from 'vuejs-logger'; 
import HomeMain from './components/modules/home/HomeMain'
import VueI18n from 'vue-i18n'
import getBrowserLocale from "@/components/util/get-browser-locale"

Vue.config.productionTip = false

const debug = process.env.NODE_ENV !== 'production'
window.baseUrl = debug ? 'https://icoev-docs.vbote.com/':'../';
//window.baseServiceUrl = debug ? 'https://icoev-docs-dev.vbote.com/icoev-docs-service/':'../icoev-docs-service/';
window.baseServiceUrl = debug ? window.icoev_docs_service_url:'/api/v1/';

// **********************************************************

Vue.use(VueI18n)


function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })
  const supportedLocales = ['es','en'];
  if (supportedLocales.includes(browserLocale)) {
    return browserLocale
  } else {
    return process.env.VUE_APP_I18N_LOCALE || "en"
  }
}

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  return messages;
}

export const i18n = new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})

// **********************************************************

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: HomeMain },
];

const router = new VueRouter({
  routes
})
 
// **********************************************************
const isProduction = process.env.NODE_ENV === 'production';

const options = {
    isEnabled: true,
    logLevel : isProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueLogger, options);


// **********************************************************

function initVue()
{
  const vue =
      new Vue({
        vuetify,
        store,
        router,
        i18n,
        render: h => h(App)
      }).$mount('#app');

  window.$vue = vue;

  //FIXME: tiene que ser dinámico
  window.$vue.$vuetify.lang.current = 'es';
}


// **********************************************************
const keycloak = Keycloak();

window.kc_profile = new Object();

// eslint-disable-next-line no-unused-vars
window.kc_logout = function () {
  keycloak.logout();
}

function kc_loadProfile() {
	keycloak.loadUserProfile().success(function(profile) {
    Vue.$log.info(profile.username);
    window.kc_profile = profile;
    window.$vue.$store.commit('icoev/setProfile', profile);
	}).error(function() {
		console.log('Failed to load profile');
		setTimeout(kc_loadProfile, 3000);
	});
}

if (keycloak.authenticated) {
    initVue();
} else {
  keycloak.init({ onLoad: 'login-required', checkLoginIframe: false }).success((auth) => {
    if (!auth) {
      window.location.reload();
      return;
    } else {
      Vue.$log.info("Authenticated");
    }

    localStorage.setItem("vue-token", keycloak.token);
    localStorage.setItem("vue-refresh-token", keycloak.refreshToken);

    if (!window.vue)
        initVue();

    kc_loadProfile();

    setInterval(() =>{
      keycloak.updateToken(70).success((refreshed)=>{
        if (refreshed) {
          Vue.$log.debug('Token refreshed'+ refreshed);
          localStorage.setItem("vue-token", keycloak.token);
        } else {
          Vue.$log.warn('Token not refreshed, valid for '
          + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
        }
      }).error(()=>{
          Vue.$log.error('Failed to refresh token');
      });


    }, 60000)

  }).error(() =>{
    Vue.$log.error("Authenticated Failed");
  });
}

window.$store = store;